// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__lSxB2","load8":"Spinner_load8__4PytU"};